import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ArrowIcon from "@mui/icons-material/ArrowRightAlt";
import parseScheduleLabel from "../../utils/scheduleTypes";
import parseDepositLabel from "../../utils/depositLabels";
const moment = require("moment");

const styles = {
  expandedBox: {
    padding: 10,
  },
  image: { width: "100%", height: "100%", objectFit: "contain" },
  paper: {
    maxWidth: "200px",
  },
  spacing: {
    borderBottom: "1px rgba(0,0,0,0.1) solid",
    padding: 5,
  },
  spacingInner: {
    padding: 5,
  },
  image_box: {
    paddingTop: 10,
  },
  arrowContainer: {
    height: "100%",
    display: "flex",
  },
  image_grid: {
    height: "auto",
  },
};

const currency = (value) => {
  return "AUD " + value.toFixed(2);
};

function capitalizeFirstLetter(string) {
  string = string.replace("_", " ");
  let stringSplit = string.split(" ");
  for (let i = 0; i < stringSplit.length; i++) {
    stringSplit[i] = stringSplit[i][0].toUpperCase() + stringSplit[i].slice(1);
  }
  return stringSplit
    .join(" ")
    .replace(/([A-Z])/g, " $1")
    .trim();
}
function capitalizeEachWord(str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr
    .join(" ")
    .replace(/([A-Z])/g, " $1")
    .trim();
}
function promotionTitle(str) {
  if (str == "weeklyRentRebate") {
    return "Weekly Rent Rebate";
  } else if (str == "hkRateOverride") {
    return "HK Rate Override";
  } else if (str == "promotionalPeriod") {
    return "Promotional Period";
  } else {
    return capitalizeFirstLetter(str);
  }
}

export default function ExpandedAudit(props) {
  const classes = styles;
  const resolveUseMonths = (newData, snapshotCurrent) => {
    if (newData && typeof newData.apply_hk_rules === "boolean") {
      return newData.apply_hk_rules;
    }
    if (snapshotCurrent && typeof snapshotCurrent.apply_hk_rules === "boolean") {
      return snapshotCurrent.apply_hk_rules;
    }
    return false;
  };
  const displayObjectDiff = (ne, old, headerData) => {
    let items = Object.keys(ne);
    let header = false;
    let hasUpdate = false;
    for (var i = 0; i < items.length; i++) {
      let value = items[i];
      if (old) {
        if (ne[value] != old[value]) {
          header = true;
          hasUpdate = true;
        }
      } else {
        header = true;
        hasUpdate = true;
      }
    }
    if (hasUpdate) {
      return (
        <div>
          {header && headerData}
          {items.map((value, index) => {
            let fieldname = null;
            let oldfieldname = null;
            if (value.includes("gift")) {
              console.log({ old });
              if (old && old[value] && typeof old[value] != "string") {
                old[value] = old[value].id;
              }
              let gift = props.gifts
                ? props.gifts.find((ele) =>
                    (ele.id == typeof ne[value]) == "object"
                      ? ne[value].value
                      : ne[value]
                  )
                : { name: "<DELETED>" };
              fieldname = gift?.name;
              if (old && old[value]) {
                gift = props.gifts
                  ? props.gifts.find((ele) =>
                      (ele.id == typeof old[value]) == "object"
                        ? old[value].value
                        : old[value]
                    )
                  : { name: "<DELETED>" };
                oldfieldname = gift?.name;
              }
            }
            if (value.includes("rate_type")) {
              let rateType = props.rateTypes
                ? props.rateTypes.find((ele) => ele.id == ne[value])
                : { name: "<DELETED>" };
              fieldname = rateType.name;
              if (old && old[value]) {
                rateType = props.rateTypes
                  ? props.rateTypes.find((ele) => ele.id == old[value])
                  : { name: "<DELETED>" };
                oldfieldname = rateType.name;
              }
            }

            if (old && (old[value] != undefined || old[value] != null)) {
              if (ne[value] != old[value]) {
                header = true;
                return (
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    wrap="nowrap"
                    spacing="1"
                    style={classes.spacingInner}
                  >
                    <Grid item xs="3">
                      <ListItemText secondary={capitalizeFirstLetter(value)} />
                    </Grid>
                    <Grid item xs="3">
                      <ListItemText
                        secondary={
                          <div style={{ whiteSpace: "pre-line" }}>
                            {oldfieldname ? oldfieldname : old[value]}
                          </div>
                        }
                      />
                    </Grid>
                    <Grid item xs="3">
                      <ListItemIcon>
                        <ArrowIcon />
                      </ListItemIcon>
                    </Grid>
                    <Grid item xs="3">
                      <ListItemText
                        secondary={
                          <div style={{ whiteSpace: "pre-line" }}>
                            {fieldname ? fieldname : ne[value]}
                          </div>
                        }
                      ></ListItemText>
                    </Grid>
                  </Grid>
                );
              }
            } else {
              if (value != "tariff_name" && ne[value] != null) {
                header = true;
                return (
                  <Grid item xs="12">
                    <ListItemText
                      primary={capitalizeFirstLetter(value)}
                      secondary={
                        fieldname ? fieldname : ne[value] ? ne[value] : 0
                      }
                      secondaryTypographyProps={{
                        style: { whiteSpace: "pre-line" },
                      }}
                    />
                  </Grid>
                );
              }
            }
          })}
        </div>
      );
    } else {
      return null;
    }
  };

  const displayUpdate = (newData, snapshotCurrent, value) => {
    const useMonths = resolveUseMonths(newData, snapshotCurrent);
    if (
      newData[value] != null &&
      newData[value] != undefined &&
      newData[value] !== ""
    ) {
      if (newData[value] != snapshotCurrent[value]) {
        if (
          newData[value].constructor === String ||
          newData[value].constructor === Boolean
        ) {
          let outputCurrent;
          let outputNew;
          if (newData[value] == snapshotCurrent[value].id) {
            return null;
          }
          if (
            value.toLowerCase().includes("date") ||
            value.toLowerCase().includes("range")
          ) {
            outputNew = moment(newData[value]).format("YYYY-MM-DD");
            outputCurrent = moment(snapshotCurrent[value]).format("YYYY-MM-DD");
          }
          if (value == "property" || value == "prop") {
            let property = props.properties
              ? props.properties.find((ele) => ele.id == newData[value])
              : { name: "<DELETED>" };
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={"Property"} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value].name}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {property.name}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value.includes("gift")) {
            let gift = props.gifts
              ? props.gifts.find((ele) => ele.id == newData[value])
              : { name: "<DELETED>" };
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value].name}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>{gift.name}</div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value.includes("gift")) {
            let gift = props.gifts
              ? props.gifts.find((ele) => ele.id == newData[value])
              : { name: "<DELETED>" };
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value].name}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>{gift.name}</div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value.includes("schedule")) {
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {parseScheduleLabel(snapshotCurrent[value])}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {parseScheduleLabel(newData[value])}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value.includes("gift")) {
            let gift = props.gifts
              ? props.gifts.find((ele) => ele.id == newData[value])
              : { name: "<DELETED>" };
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value].name}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>{gift.name}</div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value.includes("deposit_week")) {
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={parseDepositLabel(value, useMonths)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value]}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {newData[value]}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else if (value === "apply_hk_rules") {
            const fmtBool = (v) => (v === true ? "Yes" : "No");
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={parseDepositLabel(value, useMonths)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {fmtBool(snapshotCurrent[value])}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {fmtBool(newData[value])}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else {
            if (value == "type" && props.data.type == "promotion") {
              snapshotCurrent[value] = capitalizeEachWord(
                snapshotCurrent[value].replace(/_/g, " ")
              );
              newData[value] = capitalizeEachWord(
                newData[value].replace(/_/g, " ")
              );
            }
            if (value == "city") {
              let currentCity = props.cities
                ? props.cities.find(
                    (ele) => ele.id == snapshotCurrent[value].id
                  )
                : { name: "<DELETED>" };
              outputCurrent = currentCity.name;
              let newCity = props.cities
                ? props.cities.find((ele) => ele.id == newData[value])
                : { name: "<DELETED>" };
              outputNew = newCity.name;
            }
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {outputCurrent ? (
                          outputCurrent
                        ) : (
                          <>
                            {typeof snapshotCurrent[value] === "string" &&
                              snapshotCurrent[value]}
                            {typeof snapshotCurrent[value] === "number" &&
                              snapshotCurrent[value]}
                            {typeof snapshotCurrent[value] === "boolean" &&
                              snapshotCurrent[value].toString()}
                            {snapshotCurrent[value].id}
                          </>
                        )}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {outputNew ? (
                          outputNew
                        ) : (
                          <>{newData[value].toString()}</>
                        )}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          }
        } else if (
          newData[value].constructor === Number &&
          newData[value] !== ""
        ) {
          if (value == "company") {
            let newCompany = props.companies
              ? props.companies.find((ele) => ele.value == newData[value])
              : { name: "" };
            let oldCompany = props.companies
              ? props.companies.find(
                  (ele) => ele.value == snapshotCurrent[value]
                )
              : { name: "" };
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {newCompany.label}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {oldCompany.label}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          } else {
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {snapshotCurrent[value]}
                      </div>
                    }
                  />
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  <ListItemText
                    secondary={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {newData[value]}
                      </div>
                    }
                  ></ListItemText>
                </Grid>
              </Grid>
            );
          }
        } else if (newData[value].constructor === Array) {
          if (
            newData[value].length == 0 &&
            snapshotCurrent[value].length == 0
          ) {
            return null;
          }
          if (
            value == "promotionalPeriod" ||
            value == "weeklyRentRebate" ||
            value == "rentFreePromo" ||
            value == "hkRateOverride"
          ) {
            let promotionalPeriods = newData[value];
            let oldPeriods = snapshotCurrent[value];
            let output = [];
            promotionalPeriods.map((val, i) => {
              let oldPeriod = oldPeriods.find(
                (x) => x.tariff_name == val.tariff_name
              );
              let headerData = (
                <Grid item xs="12">
                  <ListItemText
                    primaryTypographyProps={{
                      style: {
                        fontWeight: "bold",
                      },
                    }}
                    primary={capitalizeFirstLetter(val.tariff_name)}
                  />
                </Grid>
              );
              let displayObj = displayObjectDiff(val, oldPeriod, headerData);
              if (displayObj) {
                output.push(
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    wrap="nowrap"
                    spacing="1"
                    style={classes.spacing}
                  >
                    <Grid item xs="12">
                      {displayObj}
                    </Grid>
                  </Grid>
                );
              }
            });
            if (output && output.length > 0) {
              return (
                <div style={{ padding: 5 }}>
                  <Grid item xs="12">
                    <ListItemText primary={promotionTitle(value)} />
                  </Grid>
                  {output}
                </div>
              );
            } else {
              return null;
            }
          } else if (value == "tier") {
            let tierTable = newData[value];
            let oldTierTable = snapshotCurrent[value];
            return (
              <Grid
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>
                <Grid container item xs="5">
                  {oldTierTable.length > 0 && (
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Reservation Count</TableCell>
                          <TableCell>Percentage</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {oldTierTable.map((val, indexx) => {
                          return (
                            <TableRow>
                              <TableCell>{val.count}</TableCell>
                              <TableCell>{val.percentage}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  )}
                </Grid>
                <Grid item xs="2" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid container item xs="5">
                  {tierTable.length > 0 && (
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Reservation Count</TableCell>
                          <TableCell>Percentage</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tierTable.map((val, indexx) => {
                          return (
                            <TableRow>
                              <TableCell>{val.count}</TableCell>
                              <TableCell>{val.percentage}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  )}
                </Grid>
              </Grid>
            );
          } else if (value == "room_types") {
            let oldRoomsString;
            let newRoomsString;
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>

                <Grid item xs="4">
                  {snapshotCurrent[value].map((val, i) => {
                    if (!oldRoomsString) {
                      oldRoomsString = val.name;
                    } else {
                      oldRoomsString += ", " + val.name;
                    }
                  })}
                  {oldRoomsString && (
                    <ListItemText
                      secondary={capitalizeFirstLetter(oldRoomsString)}
                    />
                  )}
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  {newData[value].map((val, i) => {
                    let room_type = props.room_types
                      ? props.room_types.find((ele) => ele.id == val)
                      : { name: "" };
                    if (!newRoomsString) {
                      newRoomsString = room_type.name;
                    } else {
                      newRoomsString += ", " + room_type.name;
                    }
                  })}
                  {newRoomsString && (
                    <ListItemText
                      secondary={capitalizeFirstLetter(newRoomsString)}
                    />
                  )}
                </Grid>
              </Grid>
            );
          } else if (value == "properties") {
            let oldPropString;
            let newPropString;

            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>

                <Grid item xs="4">
                  {snapshotCurrent[value].map((val, i) => {
                    if (!oldPropString) {
                      oldPropString = val.name;
                    } else {
                      oldPropString += ", " + val.name;
                    }
                  })}
                  {oldPropString && <ListItemText secondary={oldPropString} />}
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  {newData[value].map((val, i) => {
                    let property = props.properties
                      ? props.properties.find((ele) => ele.id == val)
                      : { name: "" };
                    if (!newPropString) {
                      newPropString = property.name;
                    } else {
                      newPropString += ", " + property.name;
                    }
                  })}
                  {newPropString && (
                    <ListItemText
                      secondary={capitalizeFirstLetter(newPropString)}
                    />
                  )}
                </Grid>
              </Grid>
            );
          } else if (value == "tags") {
            let oldTags;
            let newTags;
            return (
              <Grid
                container
                direction="row"
                alignItems="center"
                wrap="nowrap"
                spacing="1"
                style={classes.spacing}
              >
                <Grid item xs="12">
                  <ListItemText primary={capitalizeFirstLetter(value)} />
                </Grid>

                <Grid item xs="4">
                  {snapshotCurrent[value].map((val, i) => {
                    if (!oldTags) {
                      oldTags = val.name;
                    } else {
                      oldTags += ", " + val.name;
                    }
                  })}
                  {oldTags && <ListItemText secondary={oldTags} />}
                </Grid>
                <Grid item xs="4" alignItems="center" justifyContent="center">
                  <div style={classes.arrowContainer}>
                    <ListItemIcon>
                      <ArrowIcon style={classes.arrowContainer} />
                    </ListItemIcon>
                  </div>
                </Grid>
                <Grid item xs="4">
                  {newData[value].map((val, i) => {
                    if (!newTags) {
                      newTags = val.name;
                    } else {
                      newTags += ", " + val.name;
                    }
                  })}
                  {newTags && <ListItemText secondary={newTags} />}
                </Grid>
              </Grid>
            );
          }
        } else if (newData[value].ids) {
          return (
            <Grid
              container
              direction="row"
              alignItems="center"
              wrap="nowrap"
              spacing="1"
              style={classes.spacing}
            >
              <Grid item xs="12">
                <ListItemText primary={capitalizeFirstLetter(value)} />
              </Grid>
              <Grid item xs="4">
                <ListItemText
                  secondary={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {snapshotCurrent[value].ids &&
                        JSON.stringify(snapshotCurrent[value].ids)
                          .replace("[", "")
                          .replace("]", "")
                          .replace(",", ", ")}
                    </div>
                  }
                />
              </Grid>
              <Grid item xs="4" alignItems="center" justifyContent="center">
                <div style={classes.arrowContainer}>
                  <ListItemIcon>
                    <ArrowIcon style={classes.arrowContainer} />
                  </ListItemIcon>
                </div>
              </Grid>
              <Grid item xs="4">
                <ListItemText
                  secondary={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {newData[value].ids &&
                        JSON.stringify(newData[value].ids)
                          .replace("[", "")
                          .replace("]", "")
                          .replace(",", ", ")}
                    </div>
                  }
                ></ListItemText>
              </Grid>
            </Grid>
          );
        }
      }
    }
  };

  const displayNew = (newData, value) => {
    const useMonths = resolveUseMonths(newData, props.data.snapshotCurrent);
    if (newData[value] != null && newData[value] != undefined) {
      if (
        value.toLowerCase().includes("date") ||
        value.toLowerCase().includes("range")
      ) {
        newData[value] = moment(newData[value]).format("YYYY-MM-DD");
      }
      let obj = newData[value];
      if (props.data.type == "commission") {
        if (value == "agent") {
          let agentName = props.data.agent
            ? props.data.agent.agency_name
            : "<DELETED>";
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={agentName}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("amount")) {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={currency(newData[value])}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value == "date") {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={newData[value]}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        }
      } else if (
        obj.constructor === Boolean ||
        (obj.constructor === String && obj !== "")
      ) {
        if (value === "apply_hk_rules") {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={parseDepositLabel(value)}
                secondary={obj === true ? "Yes" : "No"}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        }
        if (value == "property" || value == "prop") {
          let property = props.properties
            ? props.properties.find((ele) => ele.id == newData[value])
            : { name: "" };
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter("Property")}
                secondary={property.name}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("gift")) {
          let gift = props.gifts
            ? props.gifts.find((ele) => ele.id == newData[value])
            : { name: "" };
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={gift.name}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("amount")) {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={currency(parseFloat(newData[value]))}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("schedule")) {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={parseScheduleLabel(obj)}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("deposit_week")) {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={parseDepositLabel(value, useMonths)}
                secondary={obj}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value === "apply_hk_rules") {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={parseDepositLabel(value)}
                secondary={obj === true ? "Yes" : "No"}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else {
          if (value == "type" && props.data.type == "promotion") {
            obj = capitalizeEachWord(obj.replace(/_/g, " "));
          }
          if (value == "city") {
            let city = props.cities
              ? props.cities.find((ele) => ele.id == obj)
              : "<DELETED>";
            obj = city.name;
          }
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={obj.toString()}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        }
      } else if (obj.constructor === Number && obj !== "") {
        if (value == "company") {
          let company = props.companies
            ? props.companies.find((ele) => ele.value == obj)
            : { name: "" };
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={company.label}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else if (value.includes("amount")) {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={currency(newData[value])}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        } else {
          return (
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={capitalizeFirstLetter(value)}
                secondary={obj}
                secondaryTypographyProps={{
                  style: { whiteSpace: "pre-line" },
                }}
              />
            </ListItem>
          );
        }
      } else if (obj.constructor === Array) {
        if (newData[value].length == 0) {
          return null;
        }
        if (
          value == "promotionalPeriod" ||
          value == "weeklyRentRebate" ||
          value == "rentFreePromo" ||
          value == "hkRateOverride"
        ) {
          let promotionalPeriods = newData[value];
          return (
            <div>
              <Grid item xs="12">
                <ListItemText
                  style={classes.spacingInner}
                  primary={promotionTitle(value)}
                />
              </Grid>
              {promotionalPeriods.map((val, i) => {
                let inner = Object.keys(val);
                return (
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    wrap="nowrap"
                    spacing="1"
                    style={classes.spacing}
                  >
                    <Grid item xs="12">
                      <ListItemText
                        primaryTypographyProps={{
                          style: {
                            fontWeight: "bold",
                          },
                        }}
                        primary={capitalizeFirstLetter(val.tariff_name)}
                      />
                    </Grid>
                    {inner.map((key, index) => {
                      let gift_name;
                      if (key.includes("gift")) {
                        let gift = props.gifts
                          ? props.gifts.find((ele) => ele.id == val[key])
                          : { name: "<DELETED>" };
                        gift_name = gift?.name;
                      }
                      if (key.includes("rate_type")) {
                        let rateType = props.rateTypes
                          ? props.rateTypes.find((ele) => ele.id == val[key])
                          : { name: "<DELETED>" };
                        val[key] = rateType?.name;
                      }
                      if (key != "tariff_name") {
                        return (
                          <Grid item xs="12">
                            <ListItemText
                              primary={capitalizeFirstLetter(key)}
                              secondary={
                                gift_name ? gift_name : val[key] ? val[key] : 0
                              }
                              secondaryTypographyProps={{
                                style: { whiteSpace: "pre-line" },
                              }}
                            />
                          </Grid>
                        );
                      }
                    })}
                  </Grid>
                );
              })}
            </div>
          );
        } else if (value == "tier") {
          let tierTable = newData[value];
          return (
            <div>
              <Grid item xs="12">
                <ListItemText
                  style={classes.spacingInner}
                  primary={capitalizeFirstLetter(value)}
                />
              </Grid>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Reservation Count</TableCell>
                    <TableCell>Percentage</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tierTable.map((val, indexx) => {
                    return (
                      <TableRow>
                        <TableCell>{val.count}</TableCell>
                        <TableCell>{val.percentage}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          );
        } else if (value == "room_types") {
          let roomsString;
          return (
            <>
              {newData[value].map((val, i) => {
                let room_type = props.room_types
                  ? props.room_types.find((ele) => ele.id == val)
                  : { name: "" };
                if (!roomsString) {
                  roomsString = room_type.name;
                } else {
                  roomsString += ", " + room_type.name;
                }
              })}
              {roomsString && (
                <ListItem style={classes.spacing}>
                  <ListItemText
                    primary={capitalizeFirstLetter(value)}
                    secondary={roomsString}
                    secondaryTypographyProps={{
                      style: { whiteSpace: "pre-line" },
                    }}
                  />
                </ListItem>
              )}
            </>
          );
        } else if (value == "properties") {
          let propString;
          return (
            <>
              {newData[value].map((val, i) => {
                let property = props.properties
                  ? props.properties.find((ele) => ele.id == val)
                  : { name: "" };
                if (!propString) {
                  propString = property.name;
                } else {
                  propString += ", " + property.name;
                }
              })}
              {propString && (
                <ListItem style={classes.spacing}>
                  <ListItemText
                    primary={capitalizeFirstLetter(value)}
                    secondary={propString}
                    secondaryTypographyProps={{
                      style: { whiteSpace: "pre-line" },
                    }}
                  />
                </ListItem>
              )}
            </>
          );
        } else if (value == "tags") {
          let tags;
          return (
            <>
              {newData[value].map((val, i) => {
                if (!tags) {
                  tags = val.name;
                } else {
                  tags += ", " + val.name;
                }
              })}
              {tags && (
                <ListItem style={classes.spacing}>
                  <ListItemText
                    primary={capitalizeFirstLetter(value)}
                    secondary={tags}
                    secondaryTypographyProps={{
                      style: { whiteSpace: "pre-line" },
                    }}
                  />
                </ListItem>
              )}
            </>
          );
        }
      } else if (obj.ids) {
        return (
          <ListItem style={classes.spacing}>
            <ListItemText
              primary={capitalizeFirstLetter(value)}
              secondary={JSON.stringify(newData[value].ids)
                .replace("[", "")
                .replace("]", "")
                .replace(",", ", ")}
              secondaryTypographyProps={{
                style: { whiteSpace: "pre-line" },
              }}
            />
          </ListItem>
        );
      }
    }
  };

  const displayChanges = () => {
    let newData = props.data.newData;
    let snapshotCurrent = props.data.snapshotCurrent;
    if (newData) {
      let items = Object.keys(newData);

      return (
        <div>
          {props.data.type == "credit-notes" &&
            props.data.action == "update" && (
              <>
                <ListItem style={classes.spacing}>
                  <ListItemText
                    primary={"Reservation ID"}
                    secondary={
                      props.data.snapshotCurrent.transaction?.reservationId
                    }
                  />
                </ListItem>
                <ListItem style={classes.spacing}>
                  <ListItemText
                    primary={"Trigger Date"}
                    secondary={props.data.snapshotCurrent.triggerDate}
                  />
                </ListItem>
              </>
            )}
          {items.map((value, index) => {
            if (props.data.action == "update") {
              if (
                !snapshotCurrent[value] ||
                (snapshotCurrent[value].constructor === Array &&
                  snapshotCurrent[value].length == 0)
              ) {
                return displayNew(newData, value);
              } else {
                return displayUpdate(newData, snapshotCurrent, value);
              }
            } else if (
              props.data.action == "create" ||
              props.data.action == "createManual"
            ) {
              return displayNew(newData, value);
            }
          })}
          {props.data.type == "commission-structure" &&
            props.data.agent?.agency_name && (
              <ListItem style={classes.spacing}>
                <ListItemText
                  primary={"Agent"}
                  secondary={props.data.agent.agency_name}
                />
              </ListItem>
            )}
          {props.data.type == "commission-structure" &&
            props.data.agent_reference?.newData.agency_name && (
              <ListItem style={classes.spacing}>
                <ListItemText
                  primary={"Agent"}
                  secondary={props.data.agent_reference.newData.agency_name}
                />
              </ListItem>
            )}
          {props.data.type == "addon" && props.data.newImageData && (
            <Grid
              style={classes.image_box}
              container
              direction="row"
              alignItems="center"
              wrap="nowrap"
            >
              <Grid item xs="12" style={classes.image_grid}>
                <ListItemText primary={"Display Image"} />
              </Grid>
              {props.data.snapshotCurrent && (
                <>
                  <Grid item xs="4">
                    <div style={classes.paper}>
                      <img
                        style={classes.image}
                        src={
                          props.data.snapshotCurrent
                            ? process.env.REACT_APP_BACKEND_URL +
                              props.data.snapshotCurrent.display_image.url
                            : ""
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs="4" alignItems="center" justifyContent="center">
                    <div style={classes.arrowContainer}>
                      <ListItemIcon>
                        <ArrowIcon style={classes.arrowContainer} />
                      </ListItemIcon>
                    </div>
                  </Grid>
                </>
              )}

              <Grid item xs="4">
                <div style={classes.paper}>
                  <img
                    style={classes.image}
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      props.data.newImageData.url
                    }
                  />
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      );
    } else {
      if (props.data.type == "agent") {
        return (
          <ListItemText
            primary={"Name"}
            secondary={props.data.snapshotCurrent.agency_name}
          />
        );
      } else if (props.data.type == "commission-structure") {
        console.error(props.data.snapshotCurrent.city);
        return (
          <ListItem>
            <ListItemText
              primary={"City Name"}
              secondary={props.data.snapshotCurrent.city.name}
            />
            <ListItemText
              primary={"Start Date"}
              secondary={moment(props.data.snapshotCurrent.startDate).format(
                "YYYY-MM-DD"
              )}
            />
            <ListItemText
              primary={"End Date"}
              secondary={moment(props.data.snapshotCurrent.endDate).format(
                "YYYY-MM-DD"
              )}
            />
            <ListItemText
              primary={"Type"}
              secondary={props.data.snapshotCurrent.type}
            />
            {props.data.agent && (
              <ListItemText
                primary={"Agent"}
                secondary={props.data.agent.agency_name}
              />
            )}
            {props.data.agent_reference && (
              <ListItemText
                primary={"Agent"}
                secondary={props.data.agent_reference.newData.agency_name}
              />
            )}
          </ListItem>
        );
      } else if (props.data.type == "credit-notes") {
        return (
          <>
            {props.data.snapshotCurrent.transaction && (
              <ListItem style={classes.spacing}>
                <ListItemText
                  primary={"Reservation ID"}
                  secondary={
                    props.data.snapshotCurrent.transaction?.reservationId
                  }
                />
              </ListItem>
            )}
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={"Amount"}
                secondary={currency(
                  parseFloat(props.data.snapshotCurrent.amount)
                )}
              />
            </ListItem>
            <ListItem style={classes.spacing}>
              <ListItemText
                primary={"Trigger Date"}
                secondary={props.data.snapshotCurrent.triggerDate}
              />
            </ListItem>
          </>
        );
      } else {
        return (
          <ListItemText
            primary={"Name"}
            secondary={props.data.snapshotCurrent.name}
          />
        );
      }
    }
  };

  return (
    <div style={classes.expandedBox}>
      <List>{displayChanges()}</List>
    </div>
  );
}
